import { Button, Typography } from 'antd';
import { CloseOutlined, LeftOutlined, RightOutlined } from '@ant-design/icons';
import ReactDOM from 'react-dom/client';
import { useState } from 'react';
import style from './CenterHomePopup.module.css';
import CenterHomePopup from './CenterHomePopup.jsx';

const { Paragraph } = Typography;

function CenterHomeListPopup(props) {
  const { features, closeable = true } = props;
  const [current, setCurrent] = useState(1);

  const incCurrent = () => {
    if (+current !== features.length) setCurrent(+current + 1);
  };

  const decCurrent = () => {
    if (+current !== 1) setCurrent(+current - 1);
  };

  const setViaText = (value) => {
    if (+value > features.length) {
      setCurrent(features.length);
      return;
    }
    if (+value < 1) {
      setCurrent(1);
      return;
    }
    setCurrent(value);
  };

  const onClose = () => {
    window.chPopup.remove();
    delete window.chPopup;
  };

  const onClick = (feature) => {
    const popup = document.getElementsByClassName('mapboxgl-popup-content')[0];
    ReactDOM.createRoot(popup).render(<CenterHomePopup feature={feature} />);
  };

  return (
    <div className={style.popup_wrapper}>
      {closeable && (
        <Button
          className={style.popup_close}
          icon={<CloseOutlined />}
          shape="circle"
          onClick={onClose}
        />
      )}
      {window.innerWidth > 500 ? (
        <>
          <div className={style.popup_text}>Список объявлений</div>
          <div className={style.list_counter}>
            <Button
              icon={<LeftOutlined />}
              onClick={decCurrent}
              style={{ border: 'unset' }}
            />
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                fontSize: 14,
                columnGap: 4,
              }}
            >
              <Paragraph
                style={{ marginBottom: 'unset', height: '100%' }}
                editable={{
                  onChange: setViaText,
                  triggerType: 'text',
                  // enterIcon: null,
                }}
              >
                {current}
              </Paragraph>
              <Paragraph style={{ marginBottom: 'unset', height: '100%' }}>
                / {features.length}
              </Paragraph>
            </div>
            <Button
              icon={<RightOutlined />}
              onClick={incCurrent}
              style={{ border: 'unset' }}
            />
          </div>
          <CenterHomePopup
            feature={features[Number(current) - 1]}
            popup={false}
          />
        </>
      ) : (
        <div className={style.popup_mobile_list}>
          {features.map((feature, index) => {
            return (
              <div
                key={index}
                style={{
                  border: '1px solid #F2F5F7',
                  borderRadius: 12,
                  padding: 8,
                }}
              >
                <CenterHomePopup feature={feature} popup={false} />
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default CenterHomeListPopup;
